import Layout from "@/components/Layout/index.ts";
import RootErrorBoundary from "@/components/RootErrorBoundary/index.ts";
import EmployeeProvider from "@/contexts/EmployeeProvider.tsx";
import AdminUserManagement from "@/pages/AdminUserManagement/AdminUserManagement.tsx";
import CaseDetail from "@/pages/CaseDetail/CaseDetail.tsx";
import CaseTypeDetail from "@/pages/CaseTypeDetail/CaseTypeDetail.tsx";
import CasesPage from "@/pages/CasesPage/CasesPage.tsx";
import CompanyDetail from "@/pages/CompanyDetail/CompanyDetail.tsx";
import DocumentTemplatesPage from "@/pages/DocumentTemplatesPage/DocumentTemplatesPage.tsx";
import EmployeeDetail from "@/pages/EmployeeDetail/EmployeeDetail.tsx";
import HomePage from "@/pages/HomePage/index.ts";
import LeadsPage from "@/pages/LeadsPage/LeadsPage.tsx";
import NotificationHistoryPage from "@/pages/NotificationHistoryPage/index.ts";
import PartyRoleDetail from "@/pages/PartyRoleDetail/PartyRoleDetail.tsx";
import PeoplePage from "@/pages/PeoplePage/PeoplePage.tsx";
import PersonDetail from "@/pages/PersonDetail/PersonDetail.tsx";
import PlacesPage from "@/pages/PlacesPage/PlacesPage.tsx";
import PublicClientLogin from "@/pages/PublicClientLogin/PublicClientLogin.tsx";
import ReportDemandDates from "@/pages/ReportDemandDates/ReportDemandDates.tsx";
import ReportLastTouch from "@/pages/ReportLastTouch/ReportLastTouch.tsx";
import ReportReferrals from "@/pages/ReportReferrals/ReportReferrals.tsx";

import ReportSol from "@/pages/ReportSol/ReportSol.tsx";
import TasksPage from "@/pages/TasksPage/TasksPage.tsx";
import TemplatesPage from "@/pages/TemplatesPage/TemplatesPage.tsx";
import { type RouteObject, createBrowserRouter } from "react-router-dom";

const pathRoutes: RouteObject[] = [
    {
        path: "/",
        element: <HomePage />,
    },
    {
        path: "/people",
        element: <PeoplePage />,
    },
    {
        path: "/places",
        element: <PlacesPage />,
    },
    {
        path: "/leads",
        element: <LeadsPage />,
    },
    {
        path: "/cases",
        element: <CasesPage />,
    },
    {
        path: "/tasks",
        element: <TasksPage />,
    },
    {
        path: "/notification-history",
        element: <NotificationHistoryPage />,
    },
    {
        path: "/reports/demand-dates",
        element: <ReportDemandDates />,
    },
    {
        path: "/reports/last-touch",
        element: <ReportLastTouch />,
    },

    {
        path: "/reports/sol",
        element: <ReportSol />,
    },
    {
        path: "/reports/referrals",
        element: <ReportReferrals />,
    },
    {
        path: "/case-detail/:caseId",
        element: <CaseDetail />,
    },
    {
        path: "/party-role-detail/:partyRoleUUID",
        element: <PartyRoleDetail />,
    },
    {
        path: "/case-type-detail/:caseTypeUUID",
        element: <CaseTypeDetail />,
    },
    {
        path: "/person-detail/:personId",
        element: <PersonDetail />,
    },
    {
        path: "/employee-detail/:employeeId",
        element: <EmployeeDetail />,
    },
    {
        path: "/place-detail/:placeId",
        element: <CompanyDetail />,
    },
    {
        path: "/admin/user-management",
        element: <AdminUserManagement />,
    },
    {
        path: "/admin/templates",
        element: <TemplatesPage />,
    },
    {
        path: "/admin/document-templates",
        element: <DocumentTemplatesPage />,
    },
];

const protectedRoutes: RouteObject = {
    path: "/",
    element: (
        <EmployeeProvider>
            <Layout />
        </EmployeeProvider>
    ),
    errorElement: <RootErrorBoundary />,
    children: pathRoutes,
};

const pathRoutes2: RouteObject[] = [
    {
        path: "/client-case-status",
        element: <PublicClientLogin />,
    },
];

const protectedRoutes2: RouteObject = {
    path: "/",
    errorElement: <RootErrorBoundary />,
    children: pathRoutes2,
};

export const router = createBrowserRouter([protectedRoutes, protectedRoutes2]);

if (import.meta.hot) {
    import.meta.hot.dispose(() => router.dispose());
}
